import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

interface AppBtnProps {
	name: string
	icon: string
	url: string
	index?: number
}

export const AppBtn = (props: AppBtnProps) => {
	const { name, icon, url, index } = props
	const navigate = useNavigate()

	return (
		<Box
			justifyContent="center"
			alignItems="center"
			textAlign="center"
			display="flex"
			flexDirection="column"
			className="clickable"
			onClick={() => navigate(url)}
			sx={{ position: 'relative' }}
		>
			{index !== undefined && (
				<Box
					sx={{
						position: 'absolute',
						top: 0,
						left: 0,
						backgroundColor: 'primary.main',
						color: 'white',
						borderRadius: '50%',
						width: 24,
						height: 24,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						fontSize: '0.75rem',
						fontWeight: 'bold',
						zIndex: 1
					}}
				>
					{index}
				</Box>
			)}
			<img src={icon} alt={name} width={100} height={100} />

			<Typography variant="h6" component="div" gutterBottom>
				{name}
			</Typography>
		</Box>
	)
}
